/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Internal_BadgeInputs */

const vi_product_internal_badge = /** @type {(inputs: Product_Internal_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội bộ`)
};

/**

* @param {Product_Internal_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_internal_badge = /** @type {((inputs?: Product_Internal_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Internal_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_internal_badge(inputs)
});